import { Component, Input, OnDestroy } from '@angular/core'
import { AddressMapper } from 'src/app/soft-login/mappers/AddressMapper'
import { Address, ProfileInstallation } from '../../services/backend'
import { ProfileStateService } from 'src/app/evida/profile/services/profile-state.service'
import { Subscription } from 'rxjs'
import { isBiogasProduction, getElVarmeProductionLabelKey } from 'src/app/utils/installation-utils'

@Component({
    selector: 'app-selected-installation-cell',
    templateUrl: './selected-installation-cell.component.html',
    styleUrls: ['./selected-installation-cell.component.scss'],
    standalone: false,
})
export class SelectedInstallationCellComponent implements OnDestroy {
    @Input() public installation: ProfileInstallation
    @Input() public smallSize = false
    @Input() public showMeterInfo = true
    @Input() public customerNumber: string

    public meteringPoint: string | null = null
    private sub = new Subscription()

    constructor(private profileState: ProfileStateService) {
        this.sub.add(
            this.profileState.installationDetails$.subscribe((d) => {
                this.meteringPoint = d?.meteringPoint ?? null
            })
        )
    }

    public formatAddress(address: Address): string {
        return AddressMapper.formatAddress(address)
    }

    public formatValueWithPeriod(value?: string | number | null): string {
        if (value === null || value === undefined) {
            return '-'
        }

        const normalized = `${value}`.trim()
        return normalized ? `${normalized}.` : '-'
    }

    public get meterInfo(): boolean {
        return !!(this.installation.meterUnits || this.installation.meterNumber)
    }

    /**
     * Checks if the installation is a biogas production installation.
     * Returns true only when:
     * - meterPointTypeCode = "PROD" from Xellent MeterPointTypeCodePeriods
     * - AND meterUnits does NOT contain "Elproduktion" or "Varmeproduktion" (el/varme producers are NOT biogas)
     */
    public get isProductionInstallation(): boolean {
        return isBiogasProduction(this.installation)
    }

    /**
     * Gets the i18n key for el/varme production label (Elproduktion, Varmeproduktion, or both).
     */
    public get elVarmeProductionLabel(): string | null {
        return getElVarmeProductionLabelKey(this.installation)
    }

    public ngOnDestroy(): void {
        this.sub.unsubscribe()
    }
}
